import { useState, useCallback, useEffect } from 'react';

// Theme constants
const LIGHT_THEME = 'light';
const CONTRAST_THEME = 'contrast';

const forcedColorsMedia = window.matchMedia('(-ms-high-contrast: active)');

export const useThemeHook = () => {
  const initialMode = forcedColorsMedia.matches ? CONTRAST_THEME : LIGHT_THEME;
  const [mode, setMode] = useState(initialMode);

  const handleChangeOSTheme = useCallback((event) =>
    event.matches ? setMode(CONTRAST_THEME) : setMode(LIGHT_THEME)
  );

  useEffect(() => {
    if (forcedColorsMedia.addEventListener) {
      forcedColorsMedia.addEventListener('change', handleChangeOSTheme);
    }

    return () => forcedColorsMedia.removeEventListener('change', handleChangeOSTheme);
  }, [handleChangeOSTheme]);

  return [mode];
};